import _extends from '@babel/runtime/helpers/esm/extends';
import React, { useMemo } from 'react';
import { FormInput } from './FormInput.js';
import { FormGrid } from './FormGrid.js';

const FormTemplate = ({
  childrenList = [[]],
  formik,
  errorMessage,
  ...props
}) => {
  const memoizedChildrenList = useMemo(() => childrenList.map((children, i) => children.map((child, j) => {
    return /*#__PURE__*/React.createElement(FormInput, _extends({}, child, {
      formik: formik,
      key: `${i}_${j}`
    }));
  })), [childrenList, formik]);
  return /*#__PURE__*/React.createElement(FormGrid, _extends({}, props, {
    formik: formik,
    errorMessage: errorMessage,
    childrenList: memoizedChildrenList
  }));
};

export { FormTemplate };
